/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import {
  selectDialog,
  selectStatus,
  selectmergeSucceeded,
  toggleDialog,
  setSearchValue,
  selectUserId,
  selectError,
} from './users.merge.slice';
import { postMergeUserAccountsThunk, getValidateEmailOrUsernameThunk } from './users.merge.thunk';
import { selectUserData } from '../../user/userAccounts/userAccounts.slice';

export default function useMergeUserAccount() {
  const dispatch = useDispatch();
  const [fieldToSearch, setFieldToSearch] = useState();
  const [mergeButtonActive, setMergeButtonActive] = useState();
  const [mergeAvailable, setMergeAvailable] = useState(false);

  const status = useSelector(selectStatus);
  const mergeDialog = useSelector(selectDialog);
  const currentUserData = useSelector(selectUserData);
  const userToMergeId = useSelector(selectUserId);
  const isLoading = useSelector(selectStatus) === ThunkStatus.LOADING;
  const mergeSucceeded = useSelector(selectmergeSucceeded);
  const error = useSelector(selectError);

  const onToggleMergeDialog = async (isOpen) => {
    if (isOpen) {
      dispatch(getValidateEmailOrUsernameThunk(fieldToSearch));
    } else {
      dispatch(toggleDialog(isOpen));
      dispatch(setSearchValue());
    }
  };

  const onMergeUserConfirm = () => {
    dispatch(
      postMergeUserAccountsThunk({
        currentUserId: currentUserData.id,
        userToMergeId,
      }),
    );
    setMergeButtonActive(false);
  };

  const onKeyUp = (value) => {
    setFieldToSearch(value);
    if (value.length > 0) {
      setMergeButtonActive(true);
    } else {
      setMergeButtonActive(false);
    }
  };

  useEffect(() => {
    setMergeAvailable(status === ThunkStatus.SUCCEEDED);
  }, [status]);

  return {
    isLoading,
    mergeDialog,
    mergeButtonActive,
    mergeAvailable,
    userToMergeId,
    error,
    mergeSucceeded,
    onMergeUserConfirm,
    onToggleMergeDialog,
    onKeyUp,
  };
}
